import React from 'react';
import config from '../config';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p className="footer__brand">
          California<span>•</span>Košice
        </p>
        <nav className="footer__links" aria-label="Právne dokumenty">
          <a href="/ochrana-osobnych-udajov.html" target="_blank" rel="noreferrer">
            Ochrana osobných údajov
          </a>
          <a href="/obchodne-podmienky.html" target="_blank" rel="noreferrer">
            Obchodné podmienky  </a>
                  </nav>
        <p className="footer__copy">
          © {year} {config.businessName}. Všetky práva vyhradené.
        </p>
      </div>
    </footer>
  );
}
